import { FuelDivider } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React from 'react';

const Divider = () => (
  <FuelFlex defaultProps={{ flexDirection: 'column', customPadding: `${DS_TOKENS.spacing.km6} 0` }}>
    <FuelDivider size="large" orientation="horizontal" />
  </FuelFlex>
);

export default Divider;
